import dayjs from 'dayjs'

import { VisaBulletinInfoBox } from '@/pages/_app/applicants/case-detail/ui/check-uscis-case/check-visa-bulletin/visa-bulletin-info/visa-bulletin-info-box'
import { VisaBulletinStatusText } from '@/pages/ui/visa-bulletin-status-text/visa-bulletin-status-text'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/card/card'

import { type ClientPortalVisaBulletinData } from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'
import { getLocalDate } from '@/lib/utils/datetime'
import { toVisaBulletinDate } from '@/lib/utils/visa-bulletin'

export interface VisaBulletinInfoCardProps {
  visaBulletinData?: ClientPortalVisaBulletinData
}

export const VisaBulletinInfoCard = ({ visaBulletinData }: VisaBulletinInfoCardProps) => {
  const { bulletinIcon, bulletinText, bulletinDate, filingDate, finalActionDate, priorityDate } = visaBulletinData ?? {}

  return (
    <Card className={cn('h-full')}>
      <CardHeader>
        <CardTitle className={cn('text-lg font-semibold text-black')}>Visa Bulletin Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div>
          <VisaBulletinStatusText iconType={bulletinIcon} text={bulletinText} className={cn('mb-5')} />
          <VisaBulletinInfoBox
            bulletinDate={bulletinDate ?? ''}
            filingDate={toVisaBulletinDate(filingDate ?? '')}
            finalActionDate={toVisaBulletinDate(finalActionDate ?? '')}
            priorityDate={dayjs(getLocalDate(priorityDate ?? ''))}
          />
        </div>
      </CardContent>
    </Card>
  )
}
